import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import ValidateIcon from "@material-ui/icons/Check";
import { throwErrorMessage } from "../../lib/error_helper";
import {
	clearEditingNote,
	createNote,
	saveEditingNote,
	noteIsDisabled,
} from "../../redux/siteMonitoring/noteActions";
import { Tab, Tabs } from "@material-ui/core";
import DetailsTab from "./NoteTabs/DetailsTab";
import CommentsTab from "./NoteTabs/CommentsTab";
import SwipeableViews from "react-swipeable-views";

const styles = () => ({
	appBar: {
		position: 'relative',
		marginBottom: '10px',
	},
	flex: {
		flex: 1,
	},
});

class EditNoteModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: 0,
		};
	}

	handleChange = (event, value) => {
		this.setState({ selectedTab: value });
	};

	handleChangeIndex = (index) => {
		this.setState({ selectedTab: index });
	};

	close() {
		this.setState({ selectedTab: 0 });
		this.props.clearEditingNote();
	}

	save() {
		if (!this.props.editingNote.assigned_user_id) {
			this.props.throwErrorMessage({ message: "L'utilisateur affecté doit être renseigné" });
			return;
		}

		if (!this.props.editingNote.lot_id) {
			this.props.throwErrorMessage({ message: "Le lot doit être renseigné" });
			return;
		}

		if (this.props.editingNote.creating)
			this.props.createNote(
				this.props.editingNote,
				this.props.siteMonitoring,
				this.props.notesFilters,
				this.props.activeUser
			);
		else
			this.props.saveEditingNote(
				this.props.editingNote,
				this.props.siteMonitoring,
				this.props.notesFilters,
				this.props.activeUser
			);

		this.setState({ selectedTab: 0 });
	}

	render() {
		const { classes } = this.props;

		if (!this.props.editingNote) return null;

		let disabled = noteIsDisabled(this.props.siteMonitoring, this.props.editingNote, this.props.activeUser);

		let modalTitle = "";
		if (disabled) modalTitle = "Consulter la note";
		else if (!this.props.editingNote.id) modalTitle = "Créer une note";
		else modalTitle = "Modifier une note";

		return (
			<Dialog
				fullScreen
				open={this.props.editingNote !== null}
				onClose={this.close.bind(this)}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							color="inherit"
							onClick={this.close.bind(this)}
							aria-label="Close"
						>
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" color="inherit" className={classes.flex}>
							{modalTitle}
						</Typography>
						<IconButton
							color="inherit"
							onClick={this.save.bind(this)}
							aria-label="Validate"
						>
							<ValidateIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				{this.props.editingNote !== null ? (
					<DialogContent className="without-side-padding">
						<AppBar position="static" color="default">
							<Tabs
								value={this.state.selectedTab}
								onChange={this.handleChange}
								variant="fullWidth"
								scrollButtons="auto"
								indicatorColor="primary"
								textColor="primary"
							>
								<Tab label={"Détails"} />
								<Tab label={"Commentaires"} disabled={!this.props.editingNote.id} />
							</Tabs>
						</AppBar>
						<SwipeableViews
							axis="x"
							index={this.state.selectedTab}
							onChangeIndex={this.handleChangeIndex}
						>
							<DetailsTab selectedTab={this.state.selectedTab === 0} />
							<CommentsTab selectedTab={this.state.selectedTab === 1} />
						</SwipeableViews>
					</DialogContent>
				) : null}
			</Dialog>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
		editingNote: state.notes.editingNote,
		notesFilters: state.notes.notesFilters,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		throwErrorMessage: (errObj) => dispatch(throwErrorMessage(errObj)),
		clearEditingNote: () => dispatch(clearEditingNote()),
		createNote: (note, siteMonitoring, filter, user) =>
			dispatch(createNote(note, siteMonitoring, filter, user)),
		saveEditingNote: (note, siteMonitoring, filter, user, saveChangesOnError) =>
			dispatch(saveEditingNote(note, siteMonitoring, filter, user, saveChangesOnError)),
	};
};

export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(EditNoteModal);
